package pancapp

import computation.ComputationLogic
import org.querki.jquery._
import org.scalajs.dom
import org.scalajs.dom.{document, window}

import scala.scalajs.js
import scala.scalajs.js.annotation.JSImport
import scala.util.{Failure, Success, Try}

object TutorialApp {
  def main(args: Array[String]): Unit = {
    $("document").ready(() => setupUI())
  }

  def appendPar(targetNode: dom.Node, text: String): Unit = {
    val parNode = document.createElement("p")
    val textNode = document.createTextNode(text)
    parNode.appendChild(textNode)
    targetNode.appendChild(parNode)
  }

  implicit def precisionString(v: Double, precision: Int = 1): String = s"%.${precision}f".format(v)

  var aInput: JQuery = _
  var bInput: JQuery = _
  var cInput: JQuery = _
  var dInput: JQuery = _
  var eInput: JQuery = _
  var fInput: JQuery = _
  var a1Input: JQuery = _
  var a2Input: JQuery = _
  var gInput: JQuery = _
  var smesCombo = $("#in-f")

  def bootstrapProtocolUi(): Unit = {
    println("bootstrapping UI for protocol")

    $("#proto_download").click(() => runCompute())
    $("#proto_print").click(() => window.print())
    $("#proto_print_2").click(() => window.print())

    val protoMnozstviRMatInnput = $("#proto_mnozstvi_r_mat")
    val protoCilovyObsahPojivaInnput = $("#proto_cilovy_obsah_pojiva")
    val protoMnozstviPojivaVRMatInnput = $("#proto_mnozstvi_pojiva_v_r_mat")
    val zvolenaPrisadaInput = $("#zvolena_ozivovaci_prisada")
    val penetraceJehlou = $("#penetrace_jehlou")
    val bod_meknuti = $("#bod_meknuti")
    val protoMnozstviOzivovaciPrisadyInnput = $("#proto_mnozstvi_ozivovaci_prisady")
    val protoHmostnostOzivovaciPrisadyNaRMatInnput = $("#proto_hmotnost_ozivovaci_prisady_na_r_mat")
    val protoHmostnostOzivovaciPrisadyNaTunInnput = $("#proto_hmotnost_ozivovaci_prisady_na_tun")
    val protoMnozstviNovehoPojivaInnput = $("#proto_mnozstvi_noveho_pojiva")

    val pv = ProtocolValues.fromQueyParams(window.location.href)

    val linkString: String = "index.html" + pv.createQueryParams() + "#here-we-go"
    $("#proto_back_link").attr("href", linkString)

    println("protocol vals: " + pv)

    // zadane udaje
    protoCilovyObsahPojivaInnput.text(precisionString(pv.b))
    protoMnozstviRMatInnput.text(precisionString(pv.a))
    protoMnozstviPojivaVRMatInnput.text(precisionString(pv.c))
    penetraceJehlou.text(precisionString(pv.d, 0))
    bod_meknuti.text(precisionString(pv.e))

    // vypocitane
    zvolenaPrisadaInput.text(ComputationLogic.fValMap(pv.f)._1)
    protoMnozstviOzivovaciPrisadyInnput.text(precisionString(pv.g))
    protoHmostnostOzivovaciPrisadyNaTunInnput.text(precisionString(pv.j, 2))
    protoHmostnostOzivovaciPrisadyNaRMatInnput.text(precisionString(pv.i, 2))
    protoMnozstviNovehoPojivaInnput.text(precisionString(pv.mnozstviNovehoPojiva))

    plot(pv.e, pv.d, pv.r2, pv.r1)
  }


  def setupUI(): Unit = {
    println("bootstrapping UI")

    if (document.querySelector("#in-a") != null) {

      bootstrapIndexUi()

    } else if (document.querySelector("#proto_mnozstvi_r_mat") != null) {
      bootstrapProtocolUi()
    }
  }

  private def bootstrapIndexUi(): Unit = {
    try {
      println("bootsrtaping UI for index")

      $("#showProtocol").click(() => window.location.href = "protokol.html" + Globals.ProtocolVals.createQueryParams())
      $("#runComputationButton").click(() => runCompute())
      $("document").ready(() => runCompute())

      aInput = $("#in-a")
      bInput = $("#in-b")
      cInput = $("#in-c")
      dInput = $("#in-d")
      eInput = $("#in-e")
      fInput = $("#in-f")
      a1Input = $("#in-a1")
      a2Input = $("#in-a2")
      gInput = $("#in-g")
      smesCombo = $("#in-f")

      val pv = Try(ProtocolValues.fromQueyParams(window.location.href)) match {
        case Success(v) => v
        case Failure(exception) =>
          println(exception.getMessage)
          ProtocolValues.fromQueyParams("")
      }

      println("prot vals:" + pv)

      aInput.value(pv.a.toString)
      bInput.value(pv.b.toString)

      cInput.value(pv.c.toString)
      dInput.value(pv.d.toString)
      eInput.value(pv.e.toString)

      a1Input.value(pv.a1.toString)
      a2Input.value(pv.a2.toString)
      gInput.value(pv.g.toString)

      ComputationLogic.fValMap.foreach { item =>
        if (item._1 == pv.f)
          smesCombo.append(s"""<option value="${item._1}" selected="true">${item._2._1}</option>""")
        else
          smesCombo.append(s"""<option value="${item._1}">${item._2._1}</option>""")
      }

      aInput.on("change", () => runCompute())
      bInput.on("change", () => runCompute())
      cInput.on("change", () => runCompute())
      dInput.on("change", () => runCompute())
      eInput.on("change", () => runCompute())
      fInput.on("change", () => runCompute())
      a1Input.on("change", () => runCompute())
      a2Input.on("change", () => runCompute())
      gInput.on("change", () => runCompute())
    } catch {
      case ex: Throwable =>
        println("ERROR BOOTSTRAPPING INDEX UI " + ex.getMessage + "  " + ex.getStackTraceString)
    }
  }

  def runCompute(): Unit = {
    try {
      println("running computation")
      try {
        $("#res-error").value("")
        Globals.ProtocolVals = ProtocolValues(
          a = aInput.value.toString.toDouble,
          b = bInput.value.toString.toDouble,
          c = cInput.value.toString.toDouble,
          d = dInput.value.toString.toDouble,
          e = eInput.value.toString.toDouble,
          f = fInput.value.toString.toInt,
          g = gInput.value.toString.toDouble)

        val pv = Globals.ProtocolVals


        $("#res-1").value(pv.r1.toString)
        $("#res-2").value(pv.r2.toString)

        println(s"plotting ${(pv.e, pv.d, pv.r2, pv.r1)} ")

        plot(pv.e, pv.d, pv.r2, pv.r1)
      } catch {
        case ex: Throwable =>
          println(ex.getMessage + " -- " + ex.printStackTrace())
      }
    }
    catch {
      case ex: Throwable => $("#res-error").value(ex.getMessage + " -- " + ex.getStackTrace)
    }
  }

  def plot(x1: Double, y1: Double, x2: Double, y2: Double): Unit = {
    DOMGlobalScope.plotStuffPlotly(x1, y1, x2, y2)
  }

}

@js.native
@JSImport("chartjs", "Chart")
class Chart(val x: Int) extends js.Object {

}

@js.native
object DOMGlobalScope extends js.GlobalScope {
  def plotStuffPlotly(x1: Double, y1: Double, x2: Double, y2: Double): Unit = js.native
}

object Globals {
  var ProtocolVals: ProtocolValues = ProtocolValues.fromQueyParams("")

  def init(): Unit = {
    ProtocolVals = ProtocolValues.fromQueyParams("")
  }
}






// WEBPACK FOOTER //
// /home/petr/repos/pancapp/javascriptApp/src/main/scala/pancapp/TutorialApp.scala